import axios from 'config/api';
import { FETCH_TEMPLATES_SUCCESS } from 'config/constants';

export function fetchAllTemplates() {
    return axios.get('admin/templates').then(({ data }) => {
      return {
        type: FETCH_TEMPLATES_SUCCESS,
        data: data,
      };
  });
}